import { NonFetchableEntity } from '../planJsonExportImportUtils';

// Helper function to serialze non fetchable objects
export function serializeNonFetchableEntities(nFE: NonFetchableEntity) {
  return {
    objectType: nFE.objectType,
    modelType: nFE.modelType,
    type: nFE.type,
    subType: nFE.subType,
    id: nFE.id,
    entityData: nFE.entityData,
  };
}
